export default "__VITE_ASSET__1d10d803__"